import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className="table-header-subtitle mb-15">
                Optimize Year Keywords that ranked for last year ({this.props.lastYear}) but no
                longer for current year ({this.props.currentYear}).
            </div>
        );
    }
}

export default ExtraButtons;
